import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

import { PageResource } from './page-resource';

@Injectable()
export class PageResourceService {
  constructor(private tarlV3Jsonapi: TarlV3Jsonapi) {}

  getPageResource(pageId: string): Observable<PageResource> {
    const path = this.tarlV3Jsonapi.path('/pages/{pageId}', { pageId });
    return this.tarlV3Jsonapi.getResource<PageResource>(path);
  }
}
